import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { FeatherModule } from 'angular-feather';
import { icons } from 'shared';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { authInterceptor } from '../core/interceptors/auth.interceptor';
import { errorInterceptorFn } from '../core/interceptors/error.interceptor';
import { environment } from '../environments/environment';
import { BASE_PATH } from './api';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptorFn])),
    { provide: BASE_PATH, useValue: environment.gba_gateway_api_url },
    importProvidersFrom(CommonModule),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    importProvidersFrom(FeatherModule.pick(icons)),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/locales/',
        suffix: '.json',
      }),
      fallbackLang: 'en',
      lang: 'en',
    }),
  ],
};
